<div class="main-container">
  <app-alert></app-alert>
  <app-header></app-header>
  <div class="content-container">
    <app-sidenav></app-sidenav>
    <div class="content-area">
      <router-outlet></router-outlet>
    </div>
  </div>
  <app-footer></app-footer>
</div>
